import { useState, useCallback } from 'react';

const useCompleteDocumentModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formValues, setFormValues] = useState(null);
  const [onSubmitCallback, setOnSubmitCallback] = useState(null);

  const openModal = useCallback((values, callback) => {
    setFormValues(values);
    setOnSubmitCallback(() => callback);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setFormValues(null);
    setOnSubmitCallback(null);
  }, []);

  const handleSaveAndComplete = useCallback(() => {
    if (onSubmitCallback && formValues) {
      onSubmitCallback(true, false, formValues); // complete: true, nonComplete: false
    }
    closeModal();
  }, [onSubmitCallback, formValues, closeModal]);

  const handleSendForSignature = useCallback(() => {
    if (onSubmitCallback && formValues) {
      // Add resignature: true to the payload for sending for signature
      const payloadWithResignature = {
        ...formValues,
        resignature: true,
      };
      onSubmitCallback(true, false, payloadWithResignature); // complete: true, nonComplete: false, resignature: true
    }
    closeModal();
  }, [onSubmitCallback, formValues, closeModal]);

  return {
    isOpen,
    openModal,
    closeModal,
    handleSaveAndComplete,
    handleSendForSignature,
  };
};

export default useCompleteDocumentModal;
